/*
 * LyteWork Perpetual Plaque Customizer
 *
 * This program creates a custom 8x4" top plate and manages
 * engraving for individual small plates.
 */

class PerpetualPlaqueCustomizer {
    constructor() {
        this.config = {
            logoUrl: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/Lw_logo_04_Artboard_2_Copy_3.png?v=1732912722',

            // === NEW: Top Plate Options ===
            topPlates: [
    { id: 'black-gold', name: 'Black / Gold Engraving', bgColorKey: 'Black', engravingColor: '#B8A35F' },
    { id: 'black-silver', name: 'Black / Silver Engraving', bgColorKey: 'Black', engravingColor: '#C4C4C4' } // Silver color
],
            acrylicPlate: {
                id: 'acrylic',
                name: 'Acrylic Plate',
                bgColor: '#d9d9d9', // User-specified grey
                engravingColor: '#f7f7f7' // User-specified white
            },

            // === NEW: Small Plate Visuals ===
            smallPlateImg: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/Perpetual_Plate.png?v=1762790023',
            
            // Re-used from original plaque customizer
            backgroundPlates: {
                Black: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_0sYk_Black_20Metal.png?v=1736619548',
                Silver: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_EbR7_Silver_20Metal.png?v=1736619633' // From original base plate
            },
            
            // Re-used but with new flat pricing
            basePlates: {
                Gold: { 
                    url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_7osf_Gold_20Metal.png?v=1736619642', 
                    cost: 4.99 // Flat rate
                },
                Silver: { 
                    url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_EbR7_Silver_20Metal.png?v=1736619633', 
                    cost: 4.99 // Flat rate
                }
            },

            // Re-used from original
            headlineTemplates: {
                'Corporate Awards': [
                    { name: 'Employee of the Year', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/EMPLOYEE_OF_THE_YEAR.png?v=1751592307' },
                    { name: 'Employee of the Year', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/EMPLOYEE_OF_THE_MONTH.png?v=1751592306'},
                    { name: 'Leadership Award 1', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/LEADERSHIP_1.png?v=1751592307' },
                    { name: 'Leadership Award 2', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/LEADERSHIP_2.png?v=1751592306' }
                ],
                'School Awards': [
                    { name: 'Attendance', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/ATTENDANCE.png?v=1751592306' },
                    { name: 'Citizenship', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/CITIZENSHIP_AWARD.png?v=1751592306' },
                    { name: 'Academic Excellence', url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/ACADEMIC_EXCELLENCE.png?v=1751592306' }
                ]
            },
            
            // Re-used from original
            fonts: [
                { name: 'Arial', value: 'Arial, sans-serif' },
                { name: 'Times New Roman', value: "'Times New Roman', serif" },
                { name: 'Georgia', value: 'Georgia, serif' },
                { name: 'Copperplate', value: "'Copperplate', fantasy", url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/COPRGTB.TTF?v=1751605768' },
                { name: 'Monotype Corsiva', value: "'Monotype Corsiva', cursive", url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/MTCORSVA.TTF?v=1751605992' },
                { name: 'Engravers', value: "'Engravers MT', serif", url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/ENGR.TTF?v=1751606144' }
            ],
            
            // === NEW: Fee Structure ===
            fees: {
         
        logoSetup: 15.00,
                plateEngraving: 3.99,
                cornerTacks: 1.99
            }
        };
        
        // Application state
        this.state = {
            product: {
                isAcrylic: false,
                totalPlates: 12 // Default
            },
            style: {
                // Set default in init() after checking for acrylic
                topPlate: null, 
                useBasePlate: false,
                useCornerTacks: false
            },
            headline: {
                type: 'None',
                template: null,
                customText: '',
                customFont: "'Copperplate', fantasy",
                customSize: 28,
                uploadedLogo: null,
                logoSize: 70,
                logoSetupFee: false
            },
            // === NEW: Dynamic Text Lines ===
            textLines: [
                { id: Date.now(), content: 'Recipient Name', font: "'Monotype Corsiva', cursive", size: 32 }
            ],
            // === NEW: Plate Engraving State ===
            platesToEngrave: 1,
            engravedPlates: [], // This will hold the text for each plate
            copyPlateSettings: {
                line1: false,
                line2: false
            }
        };

        this.modal = null;
        this.init();
    }

    // === Security: HTML escape helper to prevent XSS ===
    escapeHtml(str) {
        if (str == null) return '';
        return String(str)
            .replace(/&/g, '&amp;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');
    }
    
    init() {
        this.loadFonts();
        this.attachTrigger();
    }
    
    loadFonts() {
        const style = document.createElement('style');
        style.textContent = this.config.fonts
            .filter(f => f.url)
            .map(f => `@font-face { font-family: '${f.name}'; src: url('${f.url}'); }`)
            .join('\n');
        document.head.appendChild(style);
    }
    
    attachTrigger() {
        // Find trigger button on the page
        // NOTE: This class ".lw-perpetual-trigger" must be added to your product page button
        const trigger = document.querySelector('.lw-perpetual-trigger');
        if (trigger) {
            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.open();
            });
        }
    }
    
    async open() {
        await this.fetchProductData();
        this.buildModal();
        this.attachEventListeners();
        this.setupVariantChangeListener();
        this.updatePreview();
        this.updatePrice();
        this.lockBodyScroll();
        requestAnimationFrame(() => this.modal.classList.add('active'));
    }
    
    close() {
        if (this.modal) {
            this.modal.classList.remove('active');
            this.unlockBodyScroll();
            setTimeout(() => {
                if (this.modal) {
                    this.modal.remove();
                    this.modal = null;
                }
            }, 300);
        }
    }

    lockBodyScroll() {
        this.scrollY = window.scrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = `-${this.scrollY}px`;
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
    }

    unlockBodyScroll() {
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';
        window.scrollTo(0, this.scrollY || 0);
    }

    async fetchProductData(passedVariant = null) {
    try {
        // 1. Get the full product JSON (this is always needed for tags)
        const productHandleMatch = window.location.pathname.match(/\/products\/([a-z0-9-]+)/);
        if (!productHandleMatch) {
            throw new Error("Could not find product handle in URL.");
        }
        const productHandle = productHandleMatch[1];
        
        const response = await fetch(`/products/${productHandle}.js`);
        if (!response.ok) {
            throw new Error(`Failed to fetch product JSON: ${response.statusText}`);
        }
        const product = await response.json();
        
        let variant;
        
        // 2. Determine the correct variant
        if (passedVariant) {
            // --- A. Use the variant passed from the event listener ---
            console.log('Using variant passed from event listener');
            variant = passedVariant;
        } else {
            // --- B. Find the variant from the DOM (for initial load) ---
            console.log('No variant passed, finding in DOM for initial load');
            let currentVariantId = null;
            
            // Make the query more specific to the product form
            const formInput = document.querySelector('form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]');
            
            if (formInput) {
                currentVariantId = formInput.value;
            } else {
                // Final fallback to the URL (as before)
                currentVariantId = new URL(window.location).searchParams.get('variant') || product.variants[0].id;
            }
            
            variant = product.variants.find(v => v.id == currentVariantId);
        }
        
        // 3. Update the state
        if (!variant) {
            console.error("Could not find a valid variant. Defaulting to first variant.");
            variant = product.variants[0]; // Default to first variant to prevent crash
        }

        // === Check for Acrylic Tag ===
        this.state.product.isAcrylic = product.tags.includes('acrylic-perpetual');

        // === Parse Variant Title for Plate Count ===
        const match = variant.title.match(/^(\d+)/);
        const plateCount = match ? parseInt(match[1]) : 12; // Default to 12

        this.state.product = {
            ...this.state.product,
            title: product.title,
            variantId: variant.id, // The most important part
            variantTitle: variant.title,
            basePrice: variant.price / 100,
            featuredImage: variant.featured_image?.src || product.featured_image,
            totalPlates: plateCount
        };

        // === Set initial plate based on acrylic status ===
        if (this.state.product.isAcrylic) {
            this.state.style.topPlate = this.config.acrylicPlate;
        } else {
            // Check if current top plate is acrylic, if so, reset
            if (!this.state.style.topPlate || this.state.style.topPlate.id === 'acrylic') {
                 this.state.style.topPlate = this.config.topPlates[0];
            }
        }
        
    } catch (error) {
        console.error('Error fetching product:', error);
        // Fallback
        this.state.product = {
            title: 'Perpetual Plaque',
            basePrice: 100,
            featuredImage: '',
            isAcrylic: false,
            totalPlates: 12,
            variantId: null // Set to null on error
        };
        this.state.style.topPlate = this.config.topPlates[0];
    }
}

    setupVariantChangeListener() {
    // Listen for the theme's official "variant has changed" event
    document.addEventListener('variant:change', async (e) => {
        console.log('Variant changed, updating perpetual plaque data...');

        // The event 'e.detail.variant' is the new variant object.
        // We pass this directly to fetchProductData to update the state.
        const newVariant = e.detail.variant || e.variant;

        if (newVariant) {
            console.log('New variant found in event, ID:', newVariant.id);
            await this.fetchProductData(newVariant); // Pass the variant object
        } else {
            // This is a fallback in case the event is weird
            console.log('No variant in event, re-fetching from DOM.');
            await this.fetchProductData();
        }

        this.updatePrice();
        this.updatePreview();

        // Re-render tab if it's currently open
        if (this.modal && this.modal.querySelector('.lw-perpetual-tab[data-tab="plates"].active')) {
            this.switchTab('plates');
        }
        if (this.modal && this.modal.querySelector('.lw-perpetual-tab[data-tab="top-plate"].active')) {
            this.switchTab('top-plate');
        }
    });

    // We no longer need the 'select.product-option' listener,
    // as it's duplicative and was causing the race condition.
}

    buildModal() {
        this.modal = document.createElement('div');
        this.modal.className = 'lw-perpetual-modal'; // Renamed class
        this.modal.innerHTML = `
            <div class="lw-perpetual-overlay"></div>
            <div class="lw-perpetual-container">
                <header class="lw-perpetual-header">
                    <div class="lw-header-left">
                        <img src="${this.config.logoUrl}" alt="Logo" class="lw-header-logo">
                        <div>
                            <h2>${this.state.product.title}</h2>
                            <p>${this.state.product.variantTitle || ''}</p>
                        </div>
                    </div>
                    <button class="lw-perpetual-close">&times;</button>
                </header>
                
                <div class="lw-perpetual-body">
                    <div class="lw-perpetual-preview-section">
                        <div class="lw-perpetual-preview-container">
                            <div class="lw-perpetual-baseplate"></div>
                            <div class="lw-perpetual-top-plate">
                                <div class="lw-perpetual-engraving">
                                    <div class="lw-headline-layer"></div>
                                    <div class="lw-text-layer"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="lw-perpetual-options-section">
                        <div class="lw-perpetual-tabs">
                            <button class="lw-perpetual-tab active" data-tab="top-plate">Top Plate</button>
                            <button class="lw-perpetual-tab" data-tab="headline">Headline</button>
                            <button class="lw-perpetual-tab" data-tab="text">Text</button>
                            <button class="lw-perpetual-tab" data-tab="plates">Plates</button>
                        </div>
                        
                        <div class="lw-perpetual-tab-content">
                            ${this.renderTopPlateTab()}
                        </div>
                    </div>
                </div>
                
                <footer class="lw-perpetual-footer">
                    <div class="lw-perpetual-price">
                        <div class="lw-price-line-footer total">
                            <span>Total Price:</span>
                            <span class="lw-perpetual-price-value">$0.00</span>
                        </div>
                    </div>
                    <button type="button" class="lw-perpetual-btn lw-perpetual-btn-primary" id="addToCartBtn">Add to Cart</button>
                </footer>

                </div>
        `;
        document.body.appendChild(this.modal);
    }
    
    // === NEW: Tab Renderers ===

    renderTopPlateTab() {
        // If acrylic, show a simplified tab
        if (this.state.product.isAcrylic) {
            return `
            <div class="lw-perpetual-tab-pane active" data-pane="top-plate">
                <h4>Plate Style</h4>
                <p class="lw-help-text">This product uses a special acrylic top plate.</p>
                <div class="lw-color-grid" style="grid-template-columns: 1fr;">
                    <div class="lw-color-option active" data-plate-id="acrylic">
                        <span>${this.state.style.topPlate.name}</span>
                    </div>
                </div>

                <h4>Options</h4>
                ${this.renderBasePlateToggle()}

                <label class="lw-toggle-option">
                    <span class="lw-toggle">
                        <input type="checkbox" id="cornerTacksToggle" ${this.state.style.useCornerTacks ? 'checked' : ''}>
                        <span class="lw-toggle-slider"></span>
                    </span>
                    <span>Add 4 Corner Tacks (+$${this.config.fees.cornerTacks.toFixed(2)})</span>
                </label>
            </div>
            `;
        }

        // Standard wood plaque tab
        return `
            <div class="lw-perpetual-tab-pane active" data-pane="top-plate">
                <h4>Top Plate Color</h4>
                <div class="lw-color-grid">
                    ${this.config.topPlates.map(plate => `
                        <div class="lw-color-option ${this.state.style.topPlate.id === plate.id ? 'active' : ''}" 
                                 data-plate-id="${plate.id}">
                            <span>${plate.name}</span>
                        </div>
                    `).join('')}
                </div>
                
                <h4>Options</h4>
                ${this.renderBasePlateToggle()}

                <label class="lw-toggle-option">
                    <span class="lw-toggle">
                        <input type="checkbox" id="cornerTacksToggle" ${this.state.style.useCornerTacks ? 'checked' : ''}>
                        <span class="lw-toggle-slider"></span>
                    </span>
                    <span>Add 4 Corner Tacks (+$${this.config.fees.cornerTacks.toFixed(2)})</span>
                </label>
            </div>
        `;
    }

    renderBasePlateToggle() {
        return `
        <label class="lw-toggle-option">
            <span class="lw-toggle">
                <input type="checkbox" id="basePlateToggle" ${this.state.style.useBasePlate ? 'checked' : ''}>
                <span class="lw-toggle-slider"></span>
            </span>
            <span>Add Base Plate (+$${this.config.basePlates.Gold.cost.toFixed(2)})</span>
        </label>
        `;
    }

    renderHeadlineTab() {
        // Re-used from original, AI removed
        return `
            <div class="lw-perpetual-tab-pane" data-pane="headline">
                <h4>Headline Type (Top Half of Plate)</h4>
                <div class="lw-headline-types">
                    <label class="lw-radio-option ${this.state.headline.type === 'None' ? 'active' : ''}">
                        <input type="radio" name="headlineType" value="None" ${this.state.headline.type === 'None' ? 'checked' : ''}>
                        <span>No Headline</span>
                    </label>
                    <label class="lw-radio-option ${this.state.headline.type === 'Template' ? 'active' : ''}">
                        <input type="radio" name="headlineType" value="Template" ${this.state.headline.type === 'Template' ? 'checked' : ''}>
                        <span>Choose Design</span>
                    </label>
                    <label class="lw-radio-option ${this.state.headline.type === 'Custom' ? 'active' : ''}">
                        <input type="radio" name="headlineType" value="Custom" ${this.state.headline.type === 'Custom' ? 'checked' : ''}>
                        <span>Custom Text</span>
                    </label>
                    <label class="lw-radio-option ${this.state.headline.type === 'Logo' ? 'active' : ''}">
                        <input type="radio" name="headlineType" value="Logo" ${this.state.headline.type === 'Logo' ? 'checked' : ''}>
                        <span>Upload Logo</span>
                    </label>
                </div>
                
                <div id="headlineContent"></div>
            </div>
        `;
    }
    
    renderTextTab() {
        // === NEW: Dynamic Text Line Renderer ===
        return `
            <div class="lw-perpetual-tab-pane" data-pane="text">
                <h4>Text Lines (Bottom Half of Plate)</h4>
                <p class="lw-help-text">Add up to 5 lines of text. They will be centered and evenly spaced.</p>
                
                <div id="dynamicTextLines">
                    ${this.state.textLines.map(line => this.renderTextLineField(line)).join('')}
                </div>

                <button class="lw-perpetual-btn lw-perpetual-btn-secondary" id="addTextLineBtn" ${this.state.textLines.length >= 5 ? 'disabled' : ''}>
    + Add Line
</button>
            </div>
        `;
    }

    renderTextLineField(line) {
        return `
            <div class="lw-text-field" data-line-id="${line.id}">
                <div class="lw-field-header">
                    <label>Line ${this.state.textLines.indexOf(line) + 1}</label>
                    <div class="lw-field-controls">
                        <select class="lw-font-select" data-field="font">
                            ${this.config.fonts.map(font => 
                                `<option value="${font.value}" ${line.font === font.value ? 'selected' : ''}>${font.name}</option>`
                            ).join('')}
                        </select>
                        <div class="lw-size-control">
                            <button class="lw-size-btn" data-field="size" data-delta="-1"></button>
                            <span>${line.size}px</span>
                            <button class="lw-size-btn" data-field="size" data-delta="1">+</button>
                        </div>
                        <button class="lw-remove-line-btn" ${this.state.textLines.length <= 1 ? 'disabled' : ''}>&times;</button>
                    </div>
                </div>
                <input type="text" class="lw-text-input" data-field="content" maxlength="60" value="${this.escapeHtml(line.content)}">
            </div>
        `;
    }
    
    renderPlatesTab() {
        // === NEW: Plate Engraving Tab ===
        // Ensure plate text array is long enough
        // === NEW: Sync plate array to the exact quantity ===
if (this.state.engravedPlates.length > this.state.platesToEngrave) {
    // Truncate the array if quantity decreased
    this.state.engravedPlates = this.state.engravedPlates.slice(0, this.state.platesToEngrave);
} else {
    // Add new blank plates if quantity increased
    while (this.state.engravedPlates.length < this.state.platesToEngrave) {
        this.state.engravedPlates.push({
            line1: '',
            line2: ''
        });
    }
}
// === End of new logic ===
        
        return `
        <div class="lw-perpetual-tab-pane" data-pane="plates">
            <h4>Small Plate Engraving</h4>
            <div class="lw-info-box">
                This plaque includes <strong>${this.state.product.totalPlates} blank plates</strong>. 
                Engraving is <strong>$${this.config.fees.plateEngraving.toFixed(2)} per plate</strong>.
            </div>

            <h4>How many plates would you like to engrave now?</h4>
            <div class="lw-quantity-control">
                <button class="lw-qty-btn" data-action="decrease"></button>
                <input type="number" class="lw-qty-input" value="${this.state.platesToEngrave}" min="0" max="${this.state.product.totalPlates}">
                <button class="lw-qty-btn" data-action="increase">+</button>
            </div>

            ${this.state.platesToEngrave > 0 ? `
                <div class="lw-plates-section">
                    <h4>Engraving Details</h4>
                    
                    <div class="lw-copy-settings">
                        <h5>Copy to All Plates:</h5>
                        <label class="lw-copy-checkbox">
                            <input type="checkbox" data-copy-field="line1" ${this.state.copyPlateSettings.line1 ? 'checked' : ''}>
                            <span>Line 1</span>
                        </label>
                        <label class="lw-copy-checkbox">
                            <input type="checkbox" data-copy-field="line2" ${this.state.copyPlateSettings.line2 ? 'checked' : ''}>
                            <span>Line 2</span>
                        </label>
                    </div>
                    
                    <div class="lw-plates-table-wrapper">
                        <table class="lw-plates-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Plate</th>
                                    <th>Line 1</th>
                                    <th>Line 2 (Max 2 lines)</th>
                                </tr>
                            </thead>
                            <tbody>
                                ${this.renderPlatesTableRows()}
                            </tbody>
                        </table>
                    </div>
                </div>
            ` : ''}

            <div class="lw-price-breakdown">
                ${this.renderPriceBreakdown()}
            </div>
        </div>
        `;
    }

    renderPlatesTableRows() {
        const isAcrylic = this.state.product.isAcrylic;
        return this.state.engravedPlates.slice(0, this.state.platesToEngrave).map((plate, index) => {
            const isCopied = (field) => index > 0 && this.state.copyPlateSettings[field];
            return `
            <tr data-row-index="${index}">
                <td class="row-number">${index + 1}</td>
                <td class="row-visual">
                    <div class="lw-plate-visual ${isAcrylic ? 'acrylic' : ''}">
                        ${isAcrylic ? '<div class="hole left"></div><div class="hole right"></div>' : ''}
                    </div>
                </td>
                <td>
                    <input type="text" 
                           class="lw-table-input" 
                           data-plate-index="${index}" 
                           data-field="line1"
                           value="${this.escapeHtml(plate.line1)}"
                           placeholder="Name"
                           maxlength="30"
                           ${isCopied('line1') ? 'readonly' : ''}>
                </td>
                <td>
                    <input type="text" 
                           class="lw-table-input" 
                           data-plate-index="${index}" 
                           data-field="line2"
                           value="${this.escapeHtml(plate.line2)}"
                           placeholder="Date / Month"
                           maxlength="30"
                           ${isCopied('line2') ? 'readonly' : ''}>
                </td>
            </tr>
            `;
        }).join('');
    }

    // === Event Listeners ===
    
    attachEventListeners() {
        // Close button
        this.modal.querySelector('.lw-perpetual-close').addEventListener('click', () => this.close());
        this.modal.querySelector('.lw-perpetual-overlay').addEventListener('click', () => this.close());
        
        // Tab switching
        this.modal.querySelectorAll('.lw-perpetual-tab').forEach(tab => {
            tab.addEventListener('click', () => this.switchTab(tab.dataset.tab));
        });

        // Initial tab events
        this.attachTopPlateEvents();

        // Add to cart
        this.modal.querySelector('#addToCartBtn').addEventListener('click', (e) => {
    e.preventDefault(); // Stop the form from submitting
    this.addToCart();
});
    }

    attachTopPlateEvents() {
        // Color options
        this.modal.querySelectorAll('[data-plate-id]').forEach(el => {
            el.addEventListener('click', () => {
                if (this.state.product.isAcrylic) return; // Don't allow change if acrylic

                const plateId = el.dataset.plateId;
                this.state.style.topPlate = this.config.topPlates.find(c => c.id === plateId);
                this.modal.querySelectorAll('[data-plate-id]').forEach(e => e.classList.remove('active'));
                el.classList.add('active');
                
                this.updatePreview();
                this.updatePrice();
            });
        });

        // Base plate toggle
        const basePlateToggle = this.modal.querySelector('#basePlateToggle');
        if (basePlateToggle) {
            basePlateToggle.addEventListener('change', (e) => {
                this.state.style.useBasePlate = e.target.checked;
                this.updatePreview();
                this.updatePrice();
            });
        }
        const tacksToggle = this.modal.querySelector('#cornerTacksToggle');
        if (tacksToggle) {
            tacksToggle.addEventListener('change', (e) => {
                this.state.style.useCornerTacks = e.target.checked;
                this.updatePreview();
                this.updatePrice();
            });
        }
    }

    attachTextEvents() {
        // Add Line Button
        const addBtn = this.modal.querySelector('#addTextLineBtn');
        if (addBtn) {
            addBtn.addEventListener('click', () => {
                if (this.state.textLines.length < 5) {
                    this.state.textLines.push({
                        id: Date.now(),
                        content: 'New Line',
                        font: "'Times New Roman', serif",
                        size: 20
                    });
                    this.switchTab('text'); // Re-renders the tab
                }
            });
        }

        // Dynamic controls for each line
        this.modal.querySelectorAll('.lw-text-field[data-line-id]').forEach(lineRow => {
            const lineId = parseInt(lineRow.dataset.lineId);
            const line = this.state.textLines.find(l => l.id === lineId);
            if (!line) return;

            // Text input
            lineRow.querySelector('.lw-text-input').addEventListener('input', (e) => {
                line.content = e.target.value;
                this.updatePreview();
            });

            // Font select
            lineRow.querySelector('.lw-font-select').addEventListener('change', (e) => {
                line.font = e.target.value;
                this.updatePreview();
            });

            // Size buttons
            lineRow.querySelectorAll('.lw-size-btn').forEach(btn => {
                btn.addEventListener('click', (e) => {
                    e.preventDefault();
                    const delta = parseInt(btn.dataset.delta);
                    line.size = Math.max(8, Math.min(48, line.size + delta));
                    lineRow.querySelector('.lw-size-control span').textContent = `${line.size}px`;
                    this.updatePreview();
                });
            });

            // Remove button
           // Remove button
lineRow.querySelector('.lw-remove-line-btn').addEventListener('click', (e) => {
    e.preventDefault();
    if (this.state.textLines.length > 1) {

        // 1. Update the state
        this.state.textLines = this.state.textLines.filter(l => l.id !== lineId);

        // 2. Immediately remove the element from the DOM
        lineRow.remove();

        // 3. Update the preview
        this.updatePreview();

        // 4. Fix the "Line X" labels
        this.modal.querySelectorAll('.lw-text-field[data-line-id]').forEach((row, index) => {
            const label = row.querySelector('.lw-field-header label');
            if (label) label.textContent = `Line ${index + 1}`;
        });

        // 5. Re-enable/disable buttons as needed
        this.modal.querySelector('#addTextLineBtn').disabled = false;
        if (this.state.textLines.length === 1) {
            this.modal.querySelector('.lw-remove-line-btn').disabled = true;
        }
    }
});
        });
    }
    
   attachPlatesTabEvents() {
    const qtyInput = this.modal.querySelector('.lw-qty-input');
    const tableBody = this.modal.querySelector('.lw-plates-table tbody');

    // Helper function to render a new row
    const renderAndAddRow = (index) => {
        const isAcrylic = this.state.product.isAcrylic;
        const plate = this.state.engravedPlates[index];
        const isCopied = (field) => index > 0 && this.state.copyPlateSettings[field];

        const tr = document.createElement('tr');
        tr.dataset.rowIndex = index;
        tr.innerHTML = `
            <td class="row-number">${index + 1}</td>
            <td class="row-visual">
                <div class="lw-plate-visual ${isAcrylic ? 'acrylic' : ''}">
                    ${isAcrylic ? '<div class="hole left"></div><div class="hole right"></div>' : ''}
                </div>
            </td>
            <td>
                <input type="text" 
                       class="lw-table-input" 
                       data-plate-index="${index}" 
                       data-field="line1"
                       value="${this.escapeHtml(plate.line1)}"
                       placeholder="Name"
                       maxlength="30"
                       ${isCopied('line1') ? 'readonly' : ''}>
            </td>
            <td>
                <input type="text" 
                       class="lw-table-input" 
                       data-plate-index="${index}" 
                       data-field="line2"
                       value="${this.escapeHtml(plate.line2)}"
                       placeholder="Date / Month"
                       maxlength="30"
                       ${isCopied('line2') ? 'readonly' : ''}>
            </td>
        `;
        // Attach listeners to the new inputs
        this.attachTableInputListeners(tr.querySelectorAll('.lw-table-input'));
        tableBody.appendChild(tr);
    };

    // Helper function to update the DOM based on quantity
    const syncTableToState = () => {
        const newQuantity = this.state.platesToEngrave;

        // 1. Sync state array (add or remove plates)
        while (this.state.engravedPlates.length < newQuantity) {
            this.state.engravedPlates.push({ line1: '', line2: '' });
        }
        while (this.state.engravedPlates.length > newQuantity) {
            this.state.engravedPlates.pop();
        }

        // 2. Sync DOM (add or remove rows)
        const rows = tableBody.querySelectorAll('tr');
        if (rows.length < newQuantity) {
            // Add rows
            for (let i = rows.length; i < newQuantity; i++) {
                renderAndAddRow(i);
            }
        } else {
            // Remove rows
            for (let i = rows.length - 1; i >= newQuantity; i--) {
                rows[i].remove();
            }
        }

        // 3. Show/hide the whole table section
        const section = this.modal.querySelector('.lw-plates-section');
        if (section) {
            section.style.display = newQuantity > 0 ? '' : 'none';
        }

        this.updatePrice();
    };

    // --- Attach Listeners ---

    // 1. Quantity buttons
    this.modal.querySelectorAll('.lw-qty-btn').forEach(btn => {
        btn.addEventListener('click', () => {
            const current = parseInt(qtyInput.value);
            let newVal;
            if (btn.dataset.action === 'increase') {
                newVal = Math.min(this.state.product.totalPlates, current + 1);
            } else {
                newVal = Math.max(0, current - 1); // Allow 0
            }
            qtyInput.value = newVal;
            this.state.platesToEngrave = newVal;

            // DO NOT REFRESH TAB - just sync the table
            syncTableToState();
        });
    });

    // 2. Quantity input
    if (qtyInput) {
        qtyInput.addEventListener('change', (e) => {
            let val = parseInt(e.target.value) || 0;
            val = Math.max(0, Math.min(this.state.product.totalPlates, val));
            e.target.value = val;
            this.state.platesToEngrave = val;

            // DO NOT REFRESH TAB - just sync the table
            syncTableToState();
        });
    }

    // 3. Table input events (delegated)
    this.attachTableInputListeners(this.modal.querySelectorAll('.lw-table-input'));

    // 4. Copy settings checkboxes
    this.modal.querySelectorAll('.lw-copy-checkbox input').forEach(cb => {
        cb.addEventListener('change', (e) => {
            const field = e.target.dataset.copyField;
            this.state.copyPlateSettings[field] = e.target.checked;

            // Manually update all inputs based on new copy setting
            const sourceValue = this.state.engravedPlates[0] ? this.state.engravedPlates[0][field] : '';

            this.modal.querySelectorAll(`.lw-table-input[data-field="${field}"]`).forEach(input => {
                const index = parseInt(input.dataset.plateIndex);
                if (index > 0) {
                    if (this.state.copyPlateSettings[field]) {
                        // Copy is ON: update value, set to readonly
                        input.value = sourceValue;
                        this.state.engravedPlates[index][field] = sourceValue; // Update state
                        input.readOnly = true;
                    } else {
                        // Copy is OFF: make writable
                        input.readOnly = false;
                    }
                }
            });
        });
    });
}

// We need to create a *new* helper function to attach listeners 
// since we're now adding/removing them dynamically.
attachTableInputListeners(inputs) {
    inputs.forEach(input => {
        // Remove old listener to prevent duplicates
        const newInput = input.cloneNode(true);
        input.parentNode.replaceChild(newInput, input);

        // Add the 'input' event listener
        newInput.addEventListener('input', (e) => {
            const index = parseInt(e.target.dataset.plateIndex);
            const field = e.target.dataset.field;
            const newValue = e.target.value;

            // Step 1: Always save the value to the plate you are typing in.
            if (this.state.engravedPlates[index]) {
                this.state.engravedPlates[index][field] = newValue;
            } else {
                console.warn(`Attempted to write to non-existent plate index: ${index}`);
                return;
            }

            // Step 2: If you are on the first row AND "copy" is on, update the others.
            if (index === 0 && this.state.copyPlateSettings[field]) {
                // Loop 1: Update the state for all other plates
                for (let i = 1; i < this.state.platesToEngrave; i++) {
                    if (this.state.engravedPlates[i]) {
                        this.state.engravedPlates[i][field] = newValue;
                    }
                }

                // Loop 2: Manually update the other input fields in the DOM
                this.modal.querySelectorAll(`.lw-table-input[data-field="${field}"]`).forEach(inputField => {
                    const inputIndex = parseInt(inputField.dataset.plateIndex);
                    if (inputIndex > 0) {
                        inputField.value = newValue;
                    }
                });
            }
        });
    });
}

    switchTab(tabName) {
        // Update active tab
        this.modal.querySelectorAll('.lw-perpetual-tab').forEach(tab => {
            tab.classList.toggle('active', tab.dataset.tab === tabName);
        });
        
        const contentArea = this.modal.querySelector('.lw-perpetual-tab-content');
        switch (tabName) {
            case 'top-plate':
                contentArea.innerHTML = this.renderTopPlateTab();
                this.attachTopPlateEvents();
                break;
            case 'headline':
                contentArea.innerHTML = this.renderHeadlineTab();
                this.attachHeadlineEvents(); // Re-used from original
                this.renderHeadlineContent(); // Re-used from original
                break;
            case 'text':
                contentArea.innerHTML = this.renderTextTab();
                this.attachTextEvents();
                break;
            case 'plates':
                contentArea.innerHTML = this.renderPlatesTab();
                this.attachPlatesTabEvents();
                break;
        }
    }
    
    // === Preview & Price ===

    updatePreview() {
        const basePlate = this.modal.querySelector('.lw-perpetual-baseplate');
        const topPlate = this.modal.querySelector('.lw-perpetual-top-plate');
        const headlineLayer = this.modal.querySelector('.lw-headline-layer');
        const textLayer = this.modal.querySelector('.lw-text-layer');
        const plateConfig = this.state.style.topPlate;

        // Update plate color
        if (this.state.product.isAcrylic) {
            topPlate.style.backgroundImage = 'none';
            topPlate.style.backgroundColor = plateConfig.bgColor;
        } else {
            topPlate.style.backgroundColor = 'none';
            topPlate.style.backgroundImage = `url('${this.config.backgroundPlates[plateConfig.bgColorKey]}')`;
        }
        
        // Update base plate
        // Update base plate
if (this.state.style.useBasePlate) {
    let basePlateUrl;

    if (this.state.style.topPlate.id === 'black-gold') {
        basePlateUrl = this.config.basePlates.Gold.url;
    } else {
        // Default to Silver for 'black-silver' and 'acrylic'
        basePlateUrl = this.config.basePlates.Silver.url;
    }

    basePlate.style.backgroundImage = `url('${basePlateUrl}')`;
    basePlate.style.setProperty('display', 'block', 'important'); // This makes it visible with higher priority
} else {
    basePlate.style.setProperty('display', 'none', 'important'); // This hides it with higher priority
}
        
        // Update headline (re-used logic)
        this.updateHeadlineLayer(headlineLayer);
        this.updateCornerTacks(); // ADD THIS LINE

        // Update dynamic text lines
        this.updateTextLayer(textLayer);
    }
    
    updateTextLayer(layer) {
        layer.innerHTML = '';
        const engravingColor = this.state.style.topPlate.engravingColor;

        this.state.textLines.forEach(line => {
            const div = document.createElement('div');
            div.className = `lw-perpetual-text-line`;
            div.style.fontFamily = line.font;
            div.style.fontSize = `${line.size}px`;
            div.style.color = engravingColor;
            div.textContent = line.content;
            layer.appendChild(div);
        });
    }
    updateCornerTacks() {
        const plate = this.modal.querySelector('.lw-perpetual-top-plate');
        let tackLayer = plate.querySelector('.lw-corner-tacks');
        
        if (this.state.style.useCornerTacks) {
            if (!tackLayer) {
                tackLayer = document.createElement('div');
                tackLayer.className = 'lw-corner-tacks';
                // Add styles for the tack layer container
                tackLayer.style.cssText = 'position: absolute; inset: 0;';
                plate.appendChild(tackLayer);
            }
            
            tackLayer.innerHTML = '';
            const tackColor = this.state.style.topPlate.id === 'black-gold' ? '#B8A35F' : '#C4C4C4';

            ['top-left', 'top-right', 'bottom-left', 'bottom-right'].forEach(pos => {
                const tack = document.createElement('div');
                tack.className = `lw-tack lw-tack-${pos}`;
                // Add styles for the tacks
                tack.style.cssText = `
                    position: absolute;
                    width: 10px;
                    height: 10px;
                    background-color: ${tackColor};
                    border-radius: 50%;
                    box-shadow: inset 0 0 2px rgba(0,0,0,0.5);
                `;
                
                // Position the tacks
                if (pos.includes('top')) tack.style.top = '10px';
                if (pos.includes('bottom')) tack.style.bottom = '10px';
                if (pos.includes('left')) tack.style.left = '10px';
                if (pos.includes('right')) tack.style.right = '10px';

                tackLayer.appendChild(tack);
            });
        } else if (tackLayer) {
            tackLayer.remove();
        }
    }
    renderPriceBreakdown() {
        const basePrice = this.state.product.basePrice || 0;
        const basePlateCost = this.state.style.useBasePlate ? this.config.basePlates.Gold.cost : 0;
        const logoCost = this.state.headline.logoSetupFee ? this.config.fees.logoSetup : 0;
        const engravingCost = this.state.platesToEngrave * this.config.fees.plateEngraving;
        const total = basePrice + basePlateCost + logoCost + engravingCost;

        let breakdown = `
            <div class="lw-price-line">
                <span>Base Plaque:</span>
                <span>$${basePrice.toFixed(2)}</span>
            </div>
        `;
        if (basePlateCost > 0) {
            breakdown += `
            <div class="lw-price-line">
                <span>Base Plate Add-on:</span>
                <span>$${basePlateCost.toFixed(2)}</span>
            </div>
            `;
        }
        if (logoCost > 0) {
            breakdown += `
            <div class="lw-price-line">
                <span>Logo Setup Fee:</span>
                <span>$${logoCost.toFixed(2)}</span>
            </div>
            `;
        }
        if (engravingCost > 0) {
            breakdown += `
            <div class="lw-price-line">
                <span>Plate Engraving (${this.state.platesToEngrave} @ $${this.config.fees.plateEngraving.toFixed(2)}/ea):</span>
                <span>$${engravingCost.toFixed(2)}</span>
            </div>
            `;
        }
        breakdown += `
            <div class="lw-price-line total">
                <span>Total:</span>
                <span>$${total.toFixed(2)}</span>
            </div>
        `;
        return breakdown;
    }
    
    calculateTotalPrice() {
        const basePrice = this.state.product.basePrice || 0;
        const basePlateCost = this.state.style.useBasePlate ? this.config.basePlates.Gold.cost : 0;
        const logoCost = this.state.headline.logoSetupFee ? this.config.fees.logoSetup : 0;
        const engravingCost = this.state.platesToEngrave * this.config.fees.plateEngraving;
        const tackCost = this.state.style.useCornerTacks ? this.config.fees.cornerTacks : 0;
        
        return basePrice + basePlateCost + logoCost + engravingCost + tackCost;
    }
    
    updatePrice() {
        const priceEl = this.modal.querySelector('.lw-perpetual-price-value');
        if (priceEl) {
            priceEl.textContent = `$${this.calculateTotalPrice().toFixed(2)}`;
        }

        // Update price breakdown in Plates tab if it's open
        const breakdownEl = this.modal.querySelector('.lw-price-breakdown');
        if (breakdownEl && this.modal.querySelector('[data-tab="plates"].active')) {
            breakdownEl.innerHTML = this.renderPriceBreakdown();
        }
    }
    
    // === Cart & Image Generation ===

    async generatePreviewImage() {
        if (typeof html2canvas === 'undefined') {
            console.error('html2canvas not loaded');
            return null;
        }

        const previewContainer = this.modal.querySelector('.lw-perpetual-preview-container');
        if (!previewContainer) return null;

        // --- Store original headline images
        const headlineImages = previewContainer.querySelectorAll('.lw-headline-layer img');
        const originalSources = new Map();
        try {
            // --- NEW FIX (V2): Pre-load the base plate background image ---
             // --- NEW FIX (V3): Pre-load ALL background images ---
                 const imagesToPreload = [];

                 // 1. Add Top Plate texture
                 if (!this.state.product.isAcrylic) {
                 const plateConfig = this.state.style.topPlate;
                // Safety check
                 if (plateConfig && this.config.backgroundPlates[plateConfig.bgColorKey]) {
                 imagesToPreload.push(this.config.backgroundPlates[plateConfig.bgColorKey]);
             }
            }

             // 2. Add Base Plate image (if used)
             if (this.state.style.useBasePlate) {
                 if (this.state.style.topPlate.id === 'black-gold') {
                     imagesToPreload.push(this.config.basePlates.Gold.url);
                 } else {
                imagesToPreload.push(this.config.basePlates.Silver.url);
                     }
             }

                 // 3. Pre-load all images in parallel
                await Promise.all(imagesToPreload.map(url => {
                return new Promise((resolve, reject) => {
                const img = new Image();
                    img.crossOrigin = "anonymous";
                    img.src = url;
                     img.onload = resolve;
                     img.onerror = () => {
                     console.error('Failed to preload image:', url);
                         resolve(); // Resolve anyway to not break the cart
                     };
                });
            }));

        console.log('All background images preloaded.');

// --- ENSURE BASE PLATE IS VISIBLE FOR CAPTURE ---
const basePlateElement = previewContainer.querySelector('.lw-perpetual-baseplate');
if (this.state.style.useBasePlate && basePlateElement) {
    let basePlateUrl;
    if (this.state.style.topPlate.id === 'black-gold') {
        basePlateUrl = this.config.basePlates.Gold.url;
    } else {
        basePlateUrl = this.config.basePlates.Silver.url;
    }
    
    // Apply all necessary styles explicitly
    basePlateElement.style.cssText = `
        display: block !important;
        background-image: url('${basePlateUrl}') !important;
        background-size: cover !important;
        background-position: center !important;
        position: absolute !important;
        width: 106.25% !important;
        height: 112.5% !important;
        top: -6.25% !important;
        left: -3.125% !important;
        z-index: 1 !important;
    `;
    
    // Force a reflow to ensure styles are applied
    basePlateElement.offsetHeight;
    
    // Give it a moment to render the background image
    await new Promise(resolve => setTimeout(resolve, 100));
    
    console.log('Base plate styles applied for capture:', basePlateElement.style.cssText);
}
// --- END BASE PLATE FIX ---
       
            // --- 1. Pre-color headline images ---
            const engravingColor = this.state.style.topPlate.engravingColor;
            for (const img of headlineImages) {
                originalSources.set(img, img.src);
                try {
                    // Use the helper function (pasted below) to colorize the templates
                    const coloredSrc = await convertImageToColoredVersion(img, engravingColor);
                    img.src = coloredSrc;
                    await new Promise((resolve, reject) => {
                        img.onload = resolve;
                        img.onerror = reject;
                    });
                } catch (error) {
                    console.error('Failed to pre-color headline:', error);
                }
            }
            await new Promise(resolve => setTimeout(resolve, 50));

            // --- 2. Capture the 8x4 Plate Design ---
// --- 2. Capture the preview including overflow for base plate ---
// Get the actual dimensions including the base plate overflow
const containerRect = previewContainer.getBoundingClientRect();
const basePlate = previewContainer.querySelector('.lw-perpetual-baseplate');
let captureX = 0;
let captureY = 0;
let captureWidth = previewContainer.scrollWidth;
let captureHeight = previewContainer.scrollHeight;

// If base plate exists and is visible, adjust capture area
if (basePlate && this.state.style.useBasePlate) {
    // Account for the base plate's overflow (6.25% top, 3.125% left)
    const extraWidth = captureWidth * 0.0625; // 6.25% total width extension
    const extraHeight = captureHeight * 0.125; // 12.5% total height extension
    captureX = -extraWidth / 2;
    captureY = -extraHeight / 2;
    captureWidth += extraWidth;
    captureHeight += extraHeight;
}

const plateCanvas = await html2canvas(previewContainer, {
    backgroundColor: null, // Transparent background
    scale: 1, // Medium resolution
    logging: false,
    allowTaint: true,
    useCORS: true,
    x: captureX,
    y: captureY,
    width: captureWidth,
    height: captureHeight,
    ignoreElements: (element) => element.tagName === 'PREDICTIVE-SEARCH'
});

            // --- 3. Load the Product Variant Image ---
            const variantImg = new Image();
            variantImg.crossOrigin = "anonymous";
            variantImg.src = this.state.product.featuredImage;
            await new Promise((resolve, reject) => {
                variantImg.onload = resolve;
                variantImg.onerror = reject;
            });

            // --- 4. Create Final Stacked Canvas ---
            const finalCanvas = document.createElement('canvas');
            const ctx = finalCanvas.getContext('2d');
            
            const plateWidth = plateCanvas.width;
            const plateHeight = plateCanvas.height;

            // Scale variant image to match the plate's width
            const variantScale = plateWidth / variantImg.width;
            const variantHeight = variantImg.height * variantScale;

            finalCanvas.width = plateWidth;
            finalCanvas.height = plateHeight + variantHeight; // Stacked height

            // Draw a white background
            ctx.fillStyle = '#FFFFFF';
            ctx.fillRect(0, 0, finalCanvas.width, finalCanvas.height);

            // Draw Plate Design at top
            ctx.drawImage(plateCanvas, 0, 0);

            // Draw Variant Image below it
            ctx.drawImage(variantImg, 0, plateHeight, plateWidth, variantHeight);

            // --- 5. Constrain output size for Shopify line item property limits ---
            // Max 400px on longest edge keeps the data URL ~15-25KB even for stacked composites.
            // The preview is for admin reference, not customer viewing, so this resolution is plenty.
            const MAX_PREVIEW_DIM = 400;
            const longestEdge = Math.max(finalCanvas.width, finalCanvas.height);
            
            if (longestEdge > MAX_PREVIEW_DIM) {
                const scale = MAX_PREVIEW_DIM / longestEdge;
                const resized = document.createElement('canvas');
                resized.width = Math.round(finalCanvas.width * scale);
                resized.height = Math.round(finalCanvas.height * scale);
                const rctx = resized.getContext('2d');
                rctx.imageSmoothingEnabled = true;
                rctx.imageSmoothingQuality = 'high';
                rctx.fillStyle = '#FFFFFF';
                rctx.fillRect(0, 0, resized.width, resized.height);
                rctx.drawImage(finalCanvas, 0, 0, resized.width, resized.height);
                return resized.toDataURL('image/jpeg', 0.7);
            }
            
            return finalCanvas.toDataURL('image/jpeg', 0.7);

        } catch (error) {
            console.error('Perpetual plaque preview generation failed:', error);
            return null;
        } finally {
            // --- 6. ALWAYS restore original headline images ---
            for (const [img, originalSrc] of originalSources.entries()) {
                img.src = originalSrc;
            }
        }
    }

    async addToCart() {
        // Guard against double-clicks while a cart-add is in progress
        if (this._addingToCart) {
            console.warn('Add to cart already in progress, ignoring duplicate click');
            return;
        }

        // Show the shared disclaimer modal. Wait for user to accept or cancel.
        if (window.LyteWorkShared && typeof window.LyteWorkShared.showDisclaimer === 'function') {
            const accepted = await window.LyteWorkShared.showDisclaimer();
            if (!accepted) return;
        } else {
            // Fail-safe fallback if shared snippet didn't load for some reason
            console.warn('LyteWorkShared not loaded; falling back to native confirm');
            if (!confirm('I confirm my engraving details are correct and accept the customization terms.')) return;
        }

        this._addingToCart = true;

        const btn = this.modal.querySelector('#addToCartBtn');
        btn.disabled = true;
        
        // Show shared loading overlay (replaces old #lw-loading and #lw-processing-overlay)
        if (window.LyteWorkShared) {
            window.LyteWorkShared.showLoading();
        }

        try {
            // Ensure html2canvas is loaded
            try {
                await ensureHtml2CanvasLoaded();
            } catch (error) {
                alert('Failed to load preview library. Please try again.');
                btn.disabled = false;
                if (window.LyteWorkShared) window.LyteWorkShared.hideLoading();
                this._addingToCart = false;
                return;
            }

            // Generate stacked preview
            const previewImage = await this.generatePreviewImage();
            
            // --- Build Cart Properties ---
            const properties = {
                '_Program': 'PerpetualPlaqueCustomizer v1.0',
                'Top Plate Color': this.state.style.topPlate.name,
                'Base Plate': this.state.style.useBasePlate ? `Yes (+$${this.config.basePlates.Gold.cost.toFixed(2)})` : 'No',
                'Corner Tacks': this.state.style.useCornerTacks ? `Yes (+$${this.config.fees.cornerTacks.toFixed(2)})` : 'No'
            };

            // Add Headline info
            let headlineInfo = 'None';
            if (this.state.headline.type === 'Template' && this.state.headline.template) {
                headlineInfo = `Template: ${this.state.headline.template.name}`;
            } else if (this.state.headline.type === 'Custom' && this.state.headline.customText) {
                headlineInfo = `Custom: ${this.state.headline.customText}`;
            } else if (this.state.headline.type === 'Logo') {
                headlineInfo = 'Uploaded Logo';
                if (this.state.headline.logoSetupFee) {
                    properties['Logo Setup Fee'] = `Yes (+$${this.config.fees.logoSetup.toFixed(2)})`;
                }
            }
            properties['Headline'] = headlineInfo;

            // Add Dynamic Text Lines
            this.state.textLines.forEach((line, index) => {
                properties[`Line ${index + 1}`] = line.content;
            });

            // Add Engraved Plates Info
            properties['Plates to Engrave'] = `${this.state.platesToEngrave} (out of ${this.state.product.totalPlates} total)`;

            // Add preview image property
            if (previewImage) {
                properties['_preview'] = previewImage;
            }

            // Add individual plate details
            if (this.state.platesToEngrave > 0) {
                // properties['_EngravedPlatesData'] = this.generatePlaquesCSV(); // Keep this commented
                this.state.engravedPlates.slice(0, this.state.platesToEngrave).forEach((plaque, index) => {
                    // properties[`--- Plate ${index + 1}`] = `---`; // Keep this commented
                    properties[`Plate ${index + 1} - Line 1`] = plaque.line1 || 'n/a';
                    properties[`Plate ${index + 1} - Line 2`] = plaque.line2 || 'n/a';
                });
            }
            
            // --- Calculate Price Add-ons ---
            const surchargeBreakdown = [];
            
            const basePlateCost = this.state.style.useBasePlate ? this.config.basePlates.Gold.cost : 0;
            if (basePlateCost > 0) {
                surchargeBreakdown.push(`Base Plate: $${basePlateCost.toFixed(2)}`);
            }

            const tackCost = this.state.style.useCornerTacks ? this.config.fees.cornerTacks : 0;
            if (tackCost > 0) {
                surchargeBreakdown.push(`4 Corner Tacks: $${tackCost.toFixed(2)}`);
            }

            const logoCost = this.state.headline.logoSetupFee ? this.config.fees.logoSetup : 0;
            if (logoCost > 0) {
                surchargeBreakdown.push(`Logo Setup: $${logoCost.toFixed(2)}`);
            }

            const engravingCost = this.state.platesToEngrave * this.config.fees.plateEngraving;
            if (engravingCost > 0) {
                 surchargeBreakdown.push(`${this.state.platesToEngrave} Engraved Plates: $${engravingCost.toFixed(2)}`);
            }

            // This is the total *additional* cost on top of the base variant price
            const totalSurchargeDollars = basePlateCost + logoCost + engravingCost + tackCost;
            const totalSurchargeInCents = Math.round(totalSurchargeDollars * 100);

            // Surcharge is now handled as a separate line item below.
            // Previously these properties were used by cart-addon-pricing.js
            // to visually inflate the cart price. That display rewrite has been
            // removed in favor of an honest two-line-item approach.

           const finalVariantId = this.state.product.variantId;

            if (!finalVariantId) {
                console.error("CRITICAL: Could not determine Variant ID from state. Add to cart will fail.");
                throw new Error("Could not determine Variant ID. Add to cart failed.");
            }

            // Generate a unique link ID to associate this product with its surcharge.
            // Used by lytework-cart-count-fix.js to clean up orphaned surcharges.
            const lwLinkId = 'lw_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8);
            properties['_lw_link_id'] = lwLinkId;
            
            // Build form data
            const formData = new FormData();
            formData.append('id', finalVariantId);
            formData.append('quantity', 1);
            Object.entries(properties).forEach(([key, value]) => {
                formData.append(`properties[${key}]`, value);
            });
                
            // Add main product to cart
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                body: formData
            });

            if (!response.ok) {
                const error = await response.json();
                throw new Error(error.description || 'Failed to add main product to cart');
            }

            // --- Add surcharge as a separate, customer-facing line item ---
            // Uses the hidden "Customization Options" variant priced at $0.01.
            // quantity = surcharge in cents, so customer is charged the exact surcharge.
            // Properties below are visible to the customer in cart & checkout (no `_` prefix).
            if (totalSurchargeInCents > 0) {
                const SURCHARGE_VARIANT_ID = '41832906817610'; // "Customization Options"

                const surchargeFormData = new FormData();
                surchargeFormData.append('id', SURCHARGE_VARIANT_ID);
                surchargeFormData.append('quantity', totalSurchargeInCents);

                surchargeFormData.append('properties[For]', this.state.product.title || 'Perpetual Plaque');
                surchargeFormData.append('properties[_lw_link_id]', lwLinkId);

                // Each surcharge item rendered as its own property line for readability.
                // surchargeBreakdown contains strings like "Base Plate: $4.99".
                surchargeBreakdown.forEach((item) => {
                    const colonIndex = item.indexOf(':');
                    if (colonIndex > -1) {
                        const label = item.substring(0, colonIndex).trim();
                        const value = item.substring(colonIndex + 1).trim();
                        surchargeFormData.append(`properties[${label}]`, value);
                    }
                });

                const surchargeResponse = await fetch('/cart/add.js', {
                    method: 'POST',
                    body: surchargeFormData
                });

                if (!surchargeResponse.ok) {
                    const surchargeError = await surchargeResponse.json();
                    console.error('Surcharge add failed:', surchargeError);

                    // Roll back the main product so cart isn't in an inconsistent state.
                    // Customer sees a clean error and original cart, not an under-priced item.
                    try {
                        await fetch('/cart/change.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                                id: finalVariantId,
                                quantity: 0
                            })
                        });
                        console.log('Rolled back main product after surcharge failure');
                    } catch (rollbackError) {
                        console.error('Rollback also failed:', rollbackError);
                    }

                    alert(
                        'Sorry, there was a problem adding your customization. ' +
                        'Your cart has not been changed. Please try again, or contact us if the problem persists.'
                    );

                    // Stop the rest of the function — don't redirect to cart
                    btn.disabled = false;
                    if (window.LyteWorkShared) window.LyteWorkShared.hideLoading();
                    return;
                }
            }

            this.close();
            sessionStorage.setItem('openCartDrawer', 'true');
            window.location.href = '/cart';

        } catch (error) {
            console.error('Cart error:', error);
            console.error(error.message);
            alert('Failed to add to cart. Please try again.');
            btn.disabled = false;
            if (window.LyteWorkShared) window.LyteWorkShared.hideLoading();
        } finally {
            // Always release the guard, even if something threw above
            this._addingToCart = false;
        }
    }

    generatePlatesCSV() {
        const headers = ['#', 'Line 1', 'Line 2'];
        const rows = [headers];
        this.state.engravedPlates.slice(0, this.state.platesToEngrave).forEach((plate, i) => {
            rows.push([
                i + 1,
                plate.line1 || '',
                plate.line2 || ''
            ]);
        });
        
        return rows.map(row => 
            row.map(cell => `"${String(cell).replace(/"/g, '""')}"`).join(',')
        ).join('\n');
    }

    // === Re-used Headline & Image Helpers (Modified) ===
    
    attachHeadlineEvents() {
        setTimeout(() => {
            const radioButtons = this.modal.querySelectorAll('input[name="headlineType"]');
            radioButtons.forEach(radio => {
                radio.addEventListener('change', (e) => {
                    this.state.headline.type = e.target.value;
                    this.modal.querySelectorAll('.lw-radio-option').forEach(opt => opt.classList.remove('active'));
                    e.target.closest('.lw-radio-option').classList.add('active');
                    this.renderHeadlineContent();
                    this.updatePreview();
                    this.updatePrice(); // For logo fee
                });
            });
            if (this.state.headline.type !== 'None') {
                this.renderHeadlineContent();
            }
        }, 50);
    }    

    renderHeadlineContent() {
        const container = this.modal.querySelector('#headlineContent');
        if (!container) return;
        
        switch (this.state.headline.type) {
            case 'Template':
                container.innerHTML = this.renderTemplateSelector();
                setTimeout(() => this.attachTemplateEvents(), 10);
                break;
            case 'Custom':
                container.innerHTML = this.renderCustomHeadline();
                setTimeout(() => this.attachCustomHeadlineEvents(), 10);
                break;
            case 'Logo':
                container.innerHTML = this.renderLogoUpload();
                setTimeout(() => this.attachLogoEvents(), 10);
                break;
            default:
                container.innerHTML = '';
        }
    }

    renderTemplateSelector() {
        const categories = Object.keys(this.config.headlineTemplates);
        const activeCategory = categories[0];
        
        return `
            <div class="lw-template-selector">
                <div class="lw-template-categories">
                    ${categories.map((cat, i) => `
                        <button class="lw-template-cat-btn ${i === 0 ? 'active' : ''}" data-category="${cat}">${cat}</button>
                    `).join('')}
                </div>
                <div class="lw-template-grid">
                    ${this.config.headlineTemplates[activeCategory].map(template => `
                        <div class="lw-template-option ${this.state.headline.template?.url === template.url ? 'active' : ''}"
                             data-url="${template.url}" data-name="${this.escapeHtml(template.name)}">
                            <img src="${template.url}" alt="${this.escapeHtml(template.name)}">
                            <span>${this.escapeHtml(template.name)}</span>
                        </div>
                    `).join('')}
                </div>
            </div>
        `;
    }

    renderCustomHeadline() {
        return `
            <div class="lw-custom-headline">
                <label>Headline Text</label>
                <input type="text" class="lw-text-input" id="customHeadlineText" 
                       value="${this.escapeHtml(this.state.headline.customText)}" 
                       placeholder="e.g., Employee of the Month"
                       maxlength="50">
                
                <div class="lw-field-controls">
                    <select class="lw-font-select" id="customHeadlineFont">
                        ${this.config.fonts.map(font => 
                            `<option value="${font.value}" ${this.state.headline.customFont === font.value ? 'selected' : ''}>${this.escapeHtml(font.name)}</option>`
                        ).join('')}
                    </select>
                    
                    <div class="lw-size-control">
                        <button class="lw-size-btn" id="headlineSizeDown"></button>
                        <span id="headlineSize">${this.state.headline.customSize}px</span>
                        <button class="lw-size-btn" id="headlineSizeUp">+</button>
                    </div>
                </div>
            </div>
        `;
    }

    renderLogoUpload() {
        return `
        <div class="lw-logo-upload">
            <p class="lw-warning"> Logo setup fee: $15.00 (one-time)</p>
            <div class="lw-upload-area ${this.state.headline.uploadedLogo ? 'has-file' : ''}" id="logoUploadArea">
                ${this.state.headline.uploadedLogo ?
                    `<img src="${this.state.headline.uploadedLogo}" alt="Logo" style="max-width: ${this.state.headline.logoSize || 70}%; max-height: ${this.state.headline.logoSize || 70}%;">` :
                    `<div class="lw-upload-prompt">
                        <span></span>
                        <span>Click to upload logo</span>
                    </div>`
                }
            </div>
            <input type="file" id="logoFileInput" accept="image/*" style="display: none;">
            
            ${this.state.headline.uploadedLogo ? `
                <div class="lw-logo-controls">
                    <label>Logo Size</label>
                    <div class="lw-logo-size-slider">
                        <input type="range" id="logoSizeSlider" min="30" max="90" value="${this.state.headline.logoSize || 70}" step="5">
                        <span id="logoSizeValue">${this.state.headline.logoSize || 70}%</span>
                    </div>
                </div>
                
                <label class="lw-checkbox-option">
                    <input type="checkbox" id="logoSetupFee" ${this.state.headline.logoSetupFee ? 'checked' : ''}>
                    <span>Add logo setup fee (+$15.00)</span>
                </label>
                <p class="lw-help-text">Skip if you've already paid for this logo</p>
            ` : ''}
        </div>
        `;
    }

    attachTemplateEvents() {
        this.modal.querySelectorAll('.lw-template-cat-btn').forEach(btn => {
            btn.addEventListener('click', () => {
                const category = btn.dataset.category;
                this.modal.querySelectorAll('.lw-template-cat-btn').forEach(b => b.classList.remove('active'));
                btn.classList.add('active');
                
                const grid = this.modal.querySelector('.lw-template-grid');
                grid.innerHTML = this.config.headlineTemplates[category].map(template => `
                    <div class="lw-template-option ${this.state.headline.template?.url === template.url ? 'active' : ''}"
                         data-url="${template.url}" data-name="${this.escapeHtml(template.name)}">
                        <img src="${template.url}" alt="${this.escapeHtml(template.name)}">
                        <span>${this.escapeHtml(template.name)}</span>
                    </div>
                `).join('');
                this.attachTemplateSelectionEvents();
            });
        });
        this.attachTemplateSelectionEvents();
    }
    
    attachTemplateSelectionEvents() {
        this.modal.querySelectorAll('.lw-template-option').forEach(el => {
            el.addEventListener('click', () => {
                this.state.headline.template = {
                    url: el.dataset.url,
                    name: el.dataset.name
                };
                this.modal.querySelectorAll('.lw-template-option').forEach(e => e.classList.remove('active'));
                el.classList.add('active');
                this.updatePreview();
            });
        });
    }
    
    attachCustomHeadlineEvents() {
        const textInput = this.modal.querySelector('#customHeadlineText');
        const fontSelect = this.modal.querySelector('#customHeadlineFont');
        const sizeDown = this.modal.querySelector('#headlineSizeDown');
        const sizeUp = this.modal.querySelector('#headlineSizeUp');

        textInput.addEventListener('input', (e) => {
            this.state.headline.customText = e.target.value;
            this.updatePreview();
        });
        fontSelect.addEventListener('change', (e) => {
            this.state.headline.customFont = e.target.value;
            this.updatePreview();
        });
        sizeDown.addEventListener('click', (e) => {
            e.preventDefault();
            this.state.headline.customSize = Math.max(16, this.state.headline.customSize - 2);
            this.modal.querySelector('#headlineSize').textContent = `${this.state.headline.customSize}px`;
            this.updatePreview();
        });
        sizeUp.addEventListener('click', (e) => {
            e.preventDefault();
            this.state.headline.customSize = Math.min(48, this.state.headline.customSize + 2);
            this.modal.querySelector('#headlineSize').textContent = `${this.state.headline.customSize}px`;
            this.updatePreview();
        });
    }
    
    attachLogoEvents() {
        const uploadArea = this.modal.querySelector('#logoUploadArea');
        const fileInput = this.modal.querySelector('#logoFileInput');
        
        uploadArea.addEventListener('click', () => fileInput.click());
        
        fileInput.addEventListener('change', (e) => {
            const file = e.target.files[0];
            if (!file) return;
            
            // Validate file type — accept common web image formats only
            const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/svg+xml', 'image/webp'];
            if (!validTypes.includes(file.type)) {
                alert('Please upload a PNG, JPG, WEBP, or SVG image. Other file types are not supported.');
                e.target.value = ''; // Clear the file input
                return;
            }
            
            // Validate file size — 5MB max
            const MAX_SIZE = 5 * 1024 * 1024; // 5MB in bytes
            if (file.size > MAX_SIZE) {
                const sizeMB = (file.size / 1024 / 1024).toFixed(1);
                alert(`Logo file is too large (${sizeMB}MB). Please upload an image under 5MB.`);
                e.target.value = '';
                return;
            }
            
            const reader = new FileReader();
            reader.onload = (event) => {
                this.state.headline.uploadedLogo = event.target.result;
                this.renderHeadlineContent();
                this.updatePreview();
            };
            reader.onerror = () => {
                alert('Failed to read the logo file. Please try again or use a different image.');
                e.target.value = '';
            };
            reader.readAsDataURL(file);
        });

        const sizeSlider = this.modal.querySelector('#logoSizeSlider');
        if (sizeSlider) {
            sizeSlider.addEventListener('input', (e) => {
                this.state.headline.logoSize = parseInt(e.target.value);
                this.modal.querySelector('#logoSizeValue').textContent = `${e.target.value}%`;
                this.updatePreview();
            });
        }
        
        const feeCheckbox = this.modal.querySelector('#logoSetupFee');
        if (feeCheckbox) {
            feeCheckbox.addEventListener('change', (e) => {
                this.state.headline.logoSetupFee = e.target.checked;
                this.updatePrice();
            });
        }
    }

    updateHeadlineLayer(layer) {
        layer.innerHTML = '';
        const engravingColor = this.state.style.topPlate.engravingColor;

        const hasHeadline = (this.state.headline.type === 'Template' && this.state.headline.template) ||
                           (this.state.headline.type === 'Custom' && this.state.headline.customText) ||
                           (this.state.headline.type === 'Logo' && this.state.headline.uploadedLogo);
        layer.parentElement.classList.toggle('has-headline', hasHeadline);
        
        if (this.state.headline.type === 'Template' && this.state.headline.template) {
            const img = document.createElement('img');
            img.src = this.state.headline.template.url;
            img.style.filter = this.getSVGFilter(engravingColor);
            layer.appendChild(img);
        } else if (this.state.headline.type === 'Custom' && this.state.headline.customText) {
            const div = document.createElement('div');
            div.className = 'lw-custom-headline';
            div.style.fontFamily = this.state.headline.customFont;
            div.style.fontSize = `${this.state.headline.customSize}px`;
            div.style.color = engravingColor;
            div.textContent = this.state.headline.customText;
            layer.appendChild(div);
        } else if (this.state.headline.type === 'Logo' && this.state.headline.uploadedLogo) {
            const img = document.createElement('img');
            img.src = this.state.headline.uploadedLogo;
            img.className = 'lw-uploaded-logo';
            img.style.maxWidth = `${this.state.headline.logoSize}%`;
            img.style.maxHeight = `${this.state.headline.logoSize}%`;
            layer.appendChild(img);
        }
    }

    getSVGFilter(color) {
        if (color === '#C4C4C4') { // Silver
            return 'brightness(0) saturate(100%) invert(79%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(98%) contrast(88%)';
        } else if (color === '#B8A35F') { // Gold
            return 'brightness(0) saturate(100%) invert(72%) sepia(15%) saturate(1149%) hue-rotate(2deg) brightness(91%) contrast(87%)';
        } else if (color === '#000000') { // Black
            return 'brightness(0) saturate(100%) invert(0%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(0%) contrast(100%)';
        } else if (color === '#f7f7f7') { // White
             return 'brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(14%) hue-rotate(242deg) brightness(104%) contrast(95%)';
        }
        return '';
    }

} //  ENDS THE CLASS

// ============================================
// HTML2CANVAS LOADER WITH PROMISE (Re-used)
// ============================================
let html2canvasLoaded = false;
let html2canvasPromise = null;

function ensureHtml2CanvasLoaded() {
    if (html2canvasLoaded) return Promise.resolve();
    if (html2canvasPromise) return html2canvasPromise;
    
    html2canvasPromise = new Promise((resolve, reject) => {
        if (typeof html2canvas !== 'undefined') {
            html2canvasLoaded = true;
            resolve();
            return;
        }
        const script = document.createElement('script');
        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js';
        script.onload = () => {
            html2canvasLoaded = true;
            resolve();
        };
        script.onerror = () => reject(new Error('Failed to load html2canvas'));
        document.head.appendChild(script);
    });
    return html2canvasPromise;
}

// ============================================
// IMAGE COLORIZER HELPER (Re-used)
// ============================================
async function convertImageToColoredVersion(imgElement, hexColor) {
    return new Promise((resolve, reject) => {
        try {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            const sourceImg = new Image();
            sourceImg.crossOrigin = 'anonymous';
            
            sourceImg.onload = function() {
                canvas.width = sourceImg.naturalWidth;
                canvas.height = sourceImg.naturalHeight;
                ctx.drawImage(sourceImg, 0, 0);
                
                const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                const data = imageData.data;
                
                const r = parseInt(hexColor.slice(1, 3), 16);
                const g = parseInt(hexColor.slice(3, 5), 16);
                const b = parseInt(hexColor.slice(5, 7), 16);

                for (let i = 0; i < data.length; i += 4) {
                    const alpha = data[i + 3];
                    if (alpha > 0) {
                        // This logic assumes the source is black/grayscale
                        // It uses the source pixel's darkness as the *alpha* for the new color
                        const intensity = data[i] / 255; // How black is it (0=black, 1=white)
                        
                        if (intensity < 0.95) { // Don't color pure white pixels
                            data[i] = r;
                            data[i + 1] = g;
                            data[i + 2] = b;
                            data[i + 3] = alpha * (1 - intensity);
                        }
                    }
                }
                ctx.putImageData(imageData, 0, 0);
                resolve(canvas.toDataURL('image/png'));
            };
            
            sourceImg.onerror = () => reject(new Error('Image load failed'));
            
            let src = imgElement.src;
            if (src.startsWith('https://cdn.shopify.com/') && !src.includes('crossorigin=anonymous')) {
                 src = src.includes('?') ? `${src}&crossorigin=anonymous` : `${src}?crossorigin=anonymous`;
            }
            sourceImg.src = src;
        } catch (error) {
            reject(error);
        }
    });
}

// === Robust Initialization ===

let customizerInstance = null;

function initializeCustomizer() {
    // Check if an old instance exists (from a bfcache restore)
    // and if the modal is still in the DOM.
    const oldModal = document.querySelector('.lw-perpetual-modal');
    if (oldModal) {
        oldModal.remove();
        // Clean up any leftover scroll lock
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';
    }

    // Always create a new instance
    customizerInstance = new PerpetualPlaqueCustomizer();
}

// Standard load
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCustomizer);
} else {
    // This handles the case where the script is loaded 'async' or 'defer'
    // and the document is already interactive or complete.
    initializeCustomizer();
}

// Handle Back/Forward cache (bfcache)
// This event fires when navigating back to a page.
window.addEventListener('pageshow', (event) => {
    // 'persisted' is true if the page was loaded from bfcache
    if (event.persisted) {
        console.log('Perpetual Plaque: Page restored from bfcache. Re-initializing.');
        // Re-run the initialization to re-attach listeners
        // and clean up any old state.
        initializeCustomizer();
    }
});